import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { StorefrontService } from './core/services/storefront.service';
import { BranchService } from './core/services/branch.service';
import { PreviewService } from './core/preview/preview.service';

import { DesktopHeaderComponent } from './shell/desktop-header.component';
import { DesktopFooterComponent } from './shell/desktop-footer.component';
import { TabBarComponent } from './shared/components/tab-bar.component';
import { CartBarComponent } from './shared/components/cart-bar.component';
import { IconComponent } from './shared/components/icon.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog.component';
import { AutoRevealDirective } from './shared/directives/auto-reveal.directive';
import { AnnouncementMarqueeComponent } from './shared/components/announcement-marquee.component';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { ItemSheetComponent } from './features/item-sheet/item-sheet.component';
import { LoginSheetComponent } from './features/login-sheet/login-sheet.component';
import { FulfillmentSheetComponent } from './features/fulfillment-sheet/fulfillment-sheet.component';
import { SearchOverlayComponent } from './features/search/search-overlay.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    AppRoutingModule,
    // standalone components used by the shell template
    DesktopHeaderComponent,
    DesktopFooterComponent,
    TabBarComponent,
    CartBarComponent,
    IconComponent,
    ConfirmDialogComponent,
    AutoRevealDirective,
    AnnouncementMarqueeComponent,
    TranslatePipe,
    ItemSheetComponent,
    LoginSheetComponent,
    SearchOverlayComponent,
    FulfillmentSheetComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // Load the published storefront config + real branches before bootstrap.
    // Live preview: starts listening now, and tells the admin `ready` (or `rejected`) as soon as
    // the brand API answers — the parent is verified against the brand's adminOrigin. Not awaited,
    // so it never holds up boot.
    { provide: APP_INITIALIZER, useFactory: (p: PreviewService) => () => { p.start(); }, deps: [PreviewService], multi: true },
    { provide: APP_INITIALIZER, useFactory: (sf: StorefrontService) => () => sf.load(), deps: [StorefrontService], multi: true },
    { provide: APP_INITIALIZER, useFactory: (b: BranchService) => () => b.load(), deps: [BranchService], multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
